import React, { useEffect, useState } from 'react';

const STORAGE_KEY = 'cookieConsent';

const ConsentGate = () => {
  const [blocked, setBlocked] = useState(false);

  const checkConsent = () => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) {
        // no saved consent -> not blocked (banner should show) but we treat as allowed to view until explicit refusal
        setBlocked(false);
        return;
      }
      const parsed = JSON.parse(raw);
      // if necessary cookies are false (shouldn't happen) or saved is false, block
      if (!parsed.saved) {
        setBlocked(false);
        return;
      }
      if (!parsed.necessary) {
        setBlocked(true);
        return;
      }
      // otherwise allow
      setBlocked(false);
    } catch (e) {
      setBlocked(false);
    }
  };

  useEffect(() => {
    checkConsent();
    const onChange = () => checkConsent();
    window.addEventListener('cookieConsentChanged', onChange);
    return () => window.removeEventListener('cookieConsentChanged', onChange);
  }, []);

  if (!blocked) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-60 flex items-center justify-center">
      <div className="bg-white dark:bg-gray-800 text-black dark:text-white rounded-lg p-6 max-w-lg mx-4">
        <h2 className="text-xl font-semibold mb-2">Accès restreint</h2>
        <p className="text-sm text-gray-700 dark:text-gray-300 mb-4">Vous avez refusé les cookies nécessaires au fonctionnement du site. L'accès est restreint tant que vous ne rétablissez pas l'acceptation des cookies nécessaires.</p>
        <div className="flex justify-end space-x-3">
          <button className="px-3 py-2 rounded border" onClick={() => {
            // open cookie settings/banner
            window.dispatchEvent(new Event('openCookieSettings'));
          }}>Gérer les cookies</button>
          <button className="px-3 py-2 rounded bg-red-600 text-white" onClick={() => { window.location.href = 'about:blank'; }}>Quitter le site</button>
        </div>
      </div>
    </div>
  );
};

export default ConsentGate;
